import { render, staticRenderFns } from "./IpBundleList.vue?vue&type=template&id=57e4d3a1&"
import script from "./IpBundleList.vue?vue&type=script&lang=js&"
export * from "./IpBundleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports